import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, OnInit, input } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

import { InputMaskModule } from '@ngneat/input-mask';
import { UntilDestroy } from '@ngneat/until-destroy';

import { TiimeFileModule, TiimeFormModule, TiimeInputContainerModule } from 'tiime-material';

import { CompanyFormBase } from '@bases/company-form/company-form.base';
import { CompanyForm } from '@forms/company-form';
import { HasRoleDirective } from '@shared-directives/has-role/has-role.directive';
import { UppercaseInputDirective } from '@shared-directives/uppercase-input/uppercase-input.directive';
import { IncludesPipe } from '@shared-pipes/includes/includes.pipe';
import { ApeCodeSelectComponent } from '@shared-selectors/ape-code-select/ape-code-select.component';
import { BusinessUnitSelectComponent } from '@shared-selectors/business-unit-select/business-unit-select.component';
import { CompanyLegalStructureAndSignatorySelectComponent } from '@shared-selectors/company-legal-structure-and-signatory-select/company-legal-structure-and-signatory-select.component';
import { LegalFormSelectComponent } from '@shared-selectors/legal-form-select/legal-form-select.component';

export type CreateCompanyFormDisplayedForms = 'siret' | 'company' | 'address';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-create-company-form',
  standalone: true,
  imports: [
    JsonPipe,
    ReactiveFormsModule,
    InputMaskModule,
    TiimeFormModule,
    TiimeFileModule,
    TiimeInputContainerModule,
    UppercaseInputDirective,
    HasRoleDirective,
    IncludesPipe,
    LegalFormSelectComponent,
    ApeCodeSelectComponent,
    BusinessUnitSelectComponent,
    CompanyLegalStructureAndSignatorySelectComponent
  ],
  templateUrl: './create-company-form.component.html',
  styleUrl: './create-company-form.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class CreateCompanyFormComponent extends CompanyFormBase implements OnInit {
  readonly displayedForms: InputSignal<CreateCompanyFormDisplayedForms[]> = input<CreateCompanyFormDisplayedForms[]>([
    'siret',
    'company',
    'address'
  ]);

  constructor(private readonly formGroupDirective: FormGroupDirective) {
    super();
  }

  ngOnInit(): void {
    this.companyForm = this.formGroupDirective.control as CompanyForm;
    this.setLegalStructureAndSignatory();
    this.resetLegalStructureAndSignatoryWhenBUChange();
  }
}
